// @flow

import { format } from 'date-fns'
import {
  SUCCESS_SEARCH,
  FAILURE_SEARCH,
  SUCCESS_CHANGE_STATUS,
  SUCCESS_CHANGE_CONTACT_PERSON,
  SUCCESS_DELETE_COMPANY_STATUS,
  SUCCESS_DELETE_COMPANY_CONTACT_PERSON,
  SUCCESS_UPDATE_COMPANY_MEMO,
  SUCCESS_UPDATE_COMPANY_FIRST_INTERVIEW_DATE,
  SUCCESS_DELETE_COMPANY_FIRST_INTERVIEW_DATE,
  SUCCESS_UPDATE_COMPANY_MY_LABELS,
} from '../actions'
import { ResultAction, Company } from '../actions'
import {
  SUCCESS_UPDATE_COMPANY_SOURCING_ROUTE,
  SUCCESS_DETOUCH_COMPANY_SOURCING_ROUTE,
  SUCCESS_UPDATE_SOURCING_ROUTE,
  SUCCESS_DELETE_SOURCING_ROUTE,
} from '../actions/sourcingAnnotation'

export type ResultState = {
  count: number
  data: Company[]
  error: boolean
}

const init: ResultState = {
  count: 0,
  data: [],
  error: false,
}

export default function result(
  state: ResultState = init,
  action: ResultAction
): ResultState {
  switch (action.type) {
    case SUCCESS_SEARCH:
      return { ...state, ...action.payload, error: false }
    case FAILURE_SEARCH:
      return { ...state, error: true }
    case SUCCESS_CHANGE_STATUS:
      return {
        ...state,
        data: state.data.map((d) =>
          d.companyId === action.payload?.companyId
            ? {
                ...d,
                investingStatus: action.payload?.name,
                investingStatusUpdated: format(new Date(), 'yyyy/MM/dd'),
              }
            : d
        ),
      }
    case SUCCESS_CHANGE_CONTACT_PERSON:
      return {
        ...state,
        data: state.data.map((d) =>
          d.companyId === action.payload?.companyId
            ? {
                ...d,
                contactPerson: {
                  firstName: action.payload.firstName,
                  lastName: action.payload.lastName,
                },
              }
            : d
        ),
      }
    case SUCCESS_DELETE_COMPANY_STATUS:
      return {
        ...state,
        data: state.data.map((d) =>
          d.companyId === action.payload?.companyId
            ? {
                ...d,
                investingStatus: undefined,
                investingStatusUpdated: undefined,
              }
            : d
        ),
      }
    case SUCCESS_DELETE_COMPANY_CONTACT_PERSON:
      return {
        ...state,
        data: state.data.map((d) =>
          d.companyId === action.payload?.companyId
            ? { ...d, contactPerson: undefined }
            : d
        ),
      }
    case SUCCESS_UPDATE_COMPANY_MEMO:
      return {
        ...state,
        data: state.data.map((company) =>
          company.companyId === action.payload?.companyId
            ? { ...company, memo: { content: action.payload?.memo } }
            : company
        ),
      }
    case SUCCESS_UPDATE_COMPANY_FIRST_INTERVIEW_DATE:
      return {
        ...state,
        data: state.data.map((company) =>
          company.companyId === action.payload?.companyId
            ? {
                ...company,
                firstInterviewDate: action.payload?.firstInterviewDate,
              }
            : company
        ),
      }
    case SUCCESS_DELETE_COMPANY_FIRST_INTERVIEW_DATE:
      return {
        ...state,
        data: state.data.map((company) =>
          company.companyId === action.payload?.companyId
            ? { ...company, firstInterviewDate: undefined }
            : company
        ),
      }
    case SUCCESS_UPDATE_COMPANY_SOURCING_ROUTE:
      return {
        ...state,
        data: state.data.map((company) =>
          company.companyId === action.payload?.companyId
            ? {
                ...company,
                sourcingRoute: {
                  id: action.payload?.sourcingRouteId,
                  name: action.payload?.sourcingRouteName,
                },
              }
            : company
        ),
      }
    case SUCCESS_DETOUCH_COMPANY_SOURCING_ROUTE:
      return {
        ...state,
        data: state.data.map((company) =>
          company.companyId === action.payload?.companyId
            ? { ...company, sourcingRoute: undefined }
            : company
        ),
      }
    case SUCCESS_UPDATE_SOURCING_ROUTE:
      return {
        ...state,
        data: state.data.map((company) =>
          company.sourcingRoute?.id === action.payload?.id
            ? {
                ...company,
                sourcingRoute: {
                  id: action.payload?.id,
                  name: action.payload?.name,
                },
              }
            : company
        ),
      }
    case SUCCESS_DELETE_SOURCING_ROUTE:
      return {
        ...state,
        data: state.data.map((company) =>
          company.sourcingRoute?.id === action.payload?.id
            ? {
                ...company,
                sourcingRoute: undefined,
              }
            : company
        ),
      }
    case SUCCESS_UPDATE_COMPANY_MY_LABELS:
      return {
        ...state,
        data: state.data.map((company) =>
          company.companyId === action.payload?.companyId
            ? {
                ...company,
                myLabels: action.payload?.companyMyLabels,
              }
            : company
        ),
      }
  }
  return state
}
